var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotificationIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.119,
    height: 25.997,
    viewBox: "0 0 26.119 25.997",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11712",
    "data-name": "Group 11712",
    transform: "translate(0 -0.696)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49518",
    "data-name": "Path 49518",
    d: "M116.262,6.913A3.108,3.108,0,1,0,113.154,3.8,3.112,3.112,0,0,0,116.262,6.913Zm.654,1.005a.368.368,0,0,0-.272-.113h-.762a.368.368,0,0,0-.272.113.354.354,0,0,0-.047.417l.408.614-.191,1.61.376,1a.115.115,0,0,0,.215,0l.376-1-.191-1.61.408-.614A.353.353,0,0,0,116.916,7.918Z",
    transform: "translate(-103.203)",
    fill: "#4165f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49519",
    "data-name": "Path 49519",
    d: "M8.273,31.577h9.574a.443.443,0,0,0,.443-.443V27.146a2.715,2.715,0,0,0-1.875-2.568l-.874-.268a.314.314,0,0,0-.388.193L13.06,30.245,10.967,24.5a.314.314,0,0,0-.387-.193l-.867.266a2.718,2.718,0,0,0-1.882,2.57v3.989A.443.443,0,0,0,8.273,31.577Zm-5.164-6.6A3.108,3.108,0,1,0,0,21.871,3.112,3.112,0,0,0,3.108,24.98Z",
    transform: "translate(0 -16.478)",
    fill: "#4165f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49520",
    "data-name": "Path 49520",
    d: "M11.439,33.525H8.964v-4.89a2.815,2.815,0,1,0-5.631,0v6.643a2.7,2.7,0,0,0,2.7,2.7H9.248v4.426a.764.764,0,0,0,.764.764h2.966a.764.764,0,0,0,.764-.764V35.828a2.3,2.3,0,0,0-2.3-2.3ZM26.051,24.98a3.108,3.108,0,1,0-3.108-3.108A3.112,3.112,0,0,0,26.051,24.98Zm0,.84a2.815,2.815,0,0,0-2.815,2.815v4.89H20.76a2.3,2.3,0,0,0-2.3,2.3v6.579a.764.764,0,0,0,.764.764h2.966a.764.764,0,0,0,.764-.764V37.98h3.212a2.7,2.7,0,0,0,2.7-2.7V28.635a2.815,2.815,0,0,0-2.815-2.815Z",
    transform: "translate(-3.04 -16.478)",
    fill: "#4165f6"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/notification-icon.05e5934c55fab6ddd14cbb0484140865.svg";
export { ForwardRef as ReactComponent };